import React from "react";
import './styles.scss';
import {useList} from "react-use";
import {TOTAL_DETAIL} from "../main-search/constant";

function BatterAnalysis(props) {
    const {onChange, selected} = props;
    const [listRadio] = useList([
        {
            value: 1,
            name: '打率'
        },{
            value: 2,
            name: '本塁打'
        },{
            value: 3,
            name: '長打率'
        },{
            value: 4,
            name: 'OPS'
        },{
            value: 5,
            name: '三振割合'
        },{
            value: 6,
            name: '四球割合'
        },{
            value: 7,
            name: 'ゴロ割合'
        },{
            value: 8,
            name: 'フライ割合'
        },{
            value: 9,
            name: 'スイング率'
        },{
            value: 10,
            name: 'コンタクト率'
        },
    ])
    return (
        <ul>
            {
                listRadio.map(item => {
                    return(
                        <li key={item.value}>
                            <label className="radio-detailed-search">{item.name}
                                <input type="radio" name="radio" checked={item.value === selected} value={item.value} onClick={() => onChange(item.value, TOTAL_DETAIL.COLUMN_GROUP)}/>
                                <span className="checkmark"/>
                            </label>
                        </li>
                    )
                })
            }
        </ul>
    )
}

export default BatterAnalysis
